import { colors } from '../teams/siteVariables';

export { colorScheme, categoryColorScheme } from './colors';

//
// BORDER STYLES
//
export const focusInnerBorderColor = colors.black;
export const focusOuterBorderColor = colors.white;

//
// SHADOW LEVELS
//
export const shadowLevel1 = '0 .2rem .4rem -.075rem rgba(0, 0, 0, .25)';
export const shadowLevel2 = '0 .4rem 0.7rem -0.1rem rgba(0, 0, 0, .25)';
export const shadowLevel3 = '0 .8rem 1rem -0.2rem rgba(0, 0, 0, .25)';
export const shadowLevel4 = '0 .6rem 1.8rem -0.4rem rgba(0, 0, 0, .25)';

export const shadow2 = '0 0 2px rgba(0, 0, 0, .24), 0 1px 2px rgba(0, 0, 0, .28)';
export const shadow4 = '0 0 2px rgba(0, 0, 0, .24), 0 2px 4px rgba(0, 0, 0, .28)';
export const shadow8 = '0 0 2px rgba(0, 0, 0, .24), 0 4px 8px rgba(0, 0, 0, .28)';
export const shadow16 = '0 0 2px rgba(0, 0, 0, .24), 0 8px 16px rgba(0, 0, 0, .28)';
export const shadow28 = '0 0 8px rgba(0, 0, 0, .40), 0 14px 28px rgba(0, 0, 0, .48)';
export const shadow64 = '0 0 8px rgba(0, 0, 0, .40), 0 32px 64px rgba(0, 0, 0, .48)';

//
// SEMANTIC ASSIGNMENTS
//
export const bodyBackground = colors.grey[650];
export const bodyColor = colors.white;
